import { IViewController } from "../../../../UserInterfaceModule/Models/IViewController";
import { ComponentService } from "../../../../UserInterfaceModule/Services/ComponentService";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { CloseDialogExpression } from "../../../Models/UserInterfaces/CloseDialogExpression";

export class CloseDialogExpressionEvaluator implements IExpressionEvaluator<CloseDialogExpression> {
    get type(): string {
        return "UserInterface.CloseDialog";
    }

    async evaluate(expression: CloseDialogExpression, context: IExpressionEvaluatorContext): Promise<any> {
        const componentService = context.GetProperty<ComponentService>(ComponentService.KEY);
        if (componentService) {
            const controller = componentService.getController<IViewController>();
            if (controller) {
                let output: Record<string, any> | undefined;
                if (expression.Output) {
                    output = await context.Evaluator.evaluate(expression.Output, context);
                }
                controller.close(output);
            }
        }
        return true;
    }
}
